module.exports = __webpack_public_path__ + "img/hong meiling_lw.1a987236.png";